import { render, staticRenderFns } from "./SubmitFileChangeBtn.vue?vue&type=template&id=b7685600&scoped=true&"
import script from "./SubmitFileChangeBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitFileChangeBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFileChangeBtn.vue?vue&type=style&index=0&id=b7685600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7685600",
  null
  
)

export default component.exports